import { z } from "zod";

import { usePartFeatures } from "#modules/part/view/usePartFeatures";
import { Features } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/Features/Features";
import { SearchSimilarPartDto } from "#modules/similarPart/infra/searchSimilarParts.api";
import { PartName } from "#modules/similarPart/view/PartName";
import { Group } from "#shared/view/components/Group";
import { SectionWrapper } from "#shared/view/components/SectionWrapper";
import { Stack } from "#shared/view/components/Stack";
import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";
import { File, ProcessStepSchema, QuoteRequestLineSchema } from "shared";
import { MaterialGradeType } from "shared";

import { PartChips } from "./PartChips";

type Props = {
  part: Omit<SearchSimilarPartDto, "quoteRequestLines"> & {
    cosineSimilarity?: number;
    quoteRequestLines?: (z.infer<typeof QuoteRequestLineSchema> & {
      processSteps?: z.infer<typeof ProcessStepSchema>[];
    })[];
    files: File[];
  };
  onClick?: () => void;
  quoteRequestLineMaterialGrade?: MaterialGradeType;
  featuresDisplayMode?: "all" | "truncate";
  onSubmitPartDimensions?: () => void;
};

export const SourcePartCard = ({
  part,
  onClick,
  quoteRequestLineMaterialGrade,
  featuresDisplayMode,
  onSubmitPartDimensions,
}: Props) => {
  const { features } = usePartFeatures(part.id);

  return (
    <SectionWrapper key={part.id} onClick={onClick}>
      <Stack gap="xxs">
        <PartName partName={part.name} />

        <Group align="flex-start" gap="xs" wrap="nowrap" grow>
          <ThumbnailOverlay part={part} size={{ width: "75%", height: "75%" }} />

          <Stack gap="xxs">
            <PartChips
              part={part}
              quoteRequestLineMaterialGrade={quoteRequestLineMaterialGrade}
              dimensionsUpdatable={true}
              onSubmitPartDimensions={onSubmitPartDimensions}
            />
            {!!features.length && (
              <Features partId={part.id} displayMode={featuresDisplayMode} partType={part.type} />
            )}
          </Stack>
        </Group>
      </Stack>
    </SectionWrapper>
  );
};
